





































































































import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import FieldSelect from '@/components/form/FieldSelect.vue';
import Button from '@/components/form/Button.vue';
import { mapGetters } from 'vuex';
import {
  EmailValidate,
  PhoneValidate,
} from '@/components/form/validate/validate';
import { DropdownList, ECurrencies, ELanguages, TDropDownList } from '@/types';
import {
  currencyList,
  languageList,
  LANGUAGE_NAME,
} from '@/configs/profileConfigs';

export default Vue.extend({
  name: 'TheProfile',
  components: { WidgetWrapper, FieldInput, FieldSelect, Button },

  props: {
    timezones: {
      type: Array as PropType<Array<DropdownList>>,
      default: () => [],
    },
  },

  mounted() {
    this.language = this.$i18n.locale.toUpperCase();
  },

  computed: {
    ...mapGetters({
      user: 'getUser',
    }),
    currencies(): TDropDownList {
      return currencyList();
    },
    defaultCurrency(): string {
      return ECurrencies.usd;
    },
    languages(): TDropDownList {
      return languageList();
    },
  },

  methods: {
    async submit() {
      if (!this.validate()) return;

      const formData = new FormData();

      if (this.user.name) {
        formData.append('name', this.user.name);
      }

      if (this.user.surname) {
        formData.append('surname', this.user.surname);
      }

      if (this.user.email) {
        formData.append('email', this.user.email);
      }

      if (this.user.phone) {
        formData.append('phone', this.user.phone.toString());
      }

      if (this.user.timezone) {
        formData.append('timezone', this.user.timezone.toString());
      }

      if (this.user.currency) {
        formData.append('currency', this.user.currency);
      }

      // TODO: Отправка на сервер, после того как функционал будет добавлени на сервере
      // if (this.user.language) {
      //   formData.append('language', this.user.language);
      // }

      const response = await this.$store.dispatch('updateProfile', formData);

      if (response.success) {
        if (response.data?.popup) {
          await this.$alert({
            title: this.$t('pages.account.popup.title'),
            content: response.data.message,
            cancelText: false,
            okText: this.$t('body.popup.buttons.ok'),
          });
        }
        window.location.href = '/';
      } else {
        if (response.data.length) {
          response.data.forEach((error) => {
            this.setErrors(error.field, error.message);
          });
        }
      }
    },
    validate() {
      this.resetErrors();
      let success = true;

      if (this.user.phone && !PhoneValidate(this.user.phone)) {
        this.setErrors('phone', this.$t('errors.incorectPhone'));
        success = false;
      }

      if (!this.user.email) {
        this.setErrors('email', this.$t('errors.empty'));
        success = false;
      }

      if (this.user.email && !EmailValidate(this.user.email)) {
        this.setErrors('email', this.$t('errors.incorectEmail'));
        success = false;
      }

      return success;
    },
    setErrors(name, value) {
      this.errors[name].push(value);
    },
    resetErrors() {
      this.errors.phone = [];
      this.errors.email = [];
    },
    changeLanguage(value: string) {
      localStorage.setItem(LANGUAGE_NAME, value.toLowerCase());
      window.location.reload();
    },
  },

  data() {
    return {
      errors: {
        name: [],
        surname: [],
        phone: [],
        email: [],
      },
      emailEdited: false,
      language: ELanguages.en as string,
    };
  },
});
